import React, { useState } from 'react';

import {
  ReferenceManyField,
  usePermissions,
} from 'react-admin';

import {
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Box,
} from '@mui/material';

import useRequestTypesChoices from '../hooks/useRequestTypesChoices';

import SelectInputButton from '../components/layout/inputFields/SelectInputButton';
import Pagination from '../components/layout/Pagination';

import { requestListMap } from '../constants/requestFeatures';
import { RequestTypes, requestTypes } from '../constants/requestTypes';
import actions, { Actions } from '../constants/actions';
import hasAccess from '../utilities/hasAccess';
import PermissionMissing from '../components/utils/PermissionMissing';

const LatestRelatedRequests = ({
  defaultType = requestTypes.TRANSACTION,
}: {
  defaultType?: RequestTypes;
}) => {
  const { permissions } = usePermissions<Actions[]>();

  const [requestType, setRequestType] = useState(defaultType);
  const { choices } = useRequestTypesChoices();

  const RequestListComponent = requestListMap[requestType];

  return (
    <Grid size={12}>
      <Card variant="outlined">
        <CardHeader
          title="Related requests"
          action={(
            <SelectInputButton
              choices={choices}
              value={requestType}
              setValue={setRequestType}
            />
          )}
        />
        <Divider />
        {hasAccess(permissions, actions.REQUEST_LIST) ? (
          <ReferenceManyField
            filter={{ requestType }}
            perPage={5}
            pagination={<Pagination disableEmptyText rowsPerPageOptions={[5, 10, 20]} />}
            reference="requests"
            target="custom.entity"
            sort={{ field: 'createdAt', order: 'DESC' }}
          >
            <RequestListComponent />
          </ReferenceManyField>
        ) : (
          <CardContent>
            <Box display="flex" alignItems="center" width="100%" flexDirection="column">
              <PermissionMissing />
            </Box>
          </CardContent>
        )}
      </Card>
    </Grid>
  );
};

export default LatestRelatedRequests;
